<template>
  <div class="card p-1">
    <div class="card-body">
      <h5 class="card-title">Deposit Address</h5>

      <div
        class="row wallet-address px-2"
        v-if="ethereumAddress != '' && ethereumAddress != null"
      >
        <div class="row">
          <div class="col-md-8">
            <p class="text-light">
              Deposits to this address are unlimited. Note that you may not be
              able to withdraw all of your funds at once if you deposit more
              than your daily withdrawal limit.
            </p>
            <input
              type="text"
              class="form-control"
              :value="ethereumAddress"
              :id="`input_address_${currency}`"
              readonly
            />
            <button
              type="button"
              class="btn btn-gradient mt-2"
              @click="copyAddressToClipboard"
            >
              Salin Alamat
            </button>
          </div>
          <div class="col-md-4 mt-4 mt-md-0">
            <qrcode-vue :value="ethereumAddress" :size="200" level="H" />
          </div>
        </div>
      </div>

      <button
        class="btn btn-outline-orange"
        v-else
        :disabled="isRequestingAddress"
        @click="requestAnAddress"
      >
        {{ isRequestingAddress ? "Loading..." : "Request an Address" }}
      </button>
    </div>
  </div>
</template>

<script>
// node_modules
import Cookies from "js-cookie";
import QrcodeVue from "qrcode.vue";
import { useToast } from "vue-toastification";

// applibs
import themain from "@/applibs/themain.js";
import thestore from "@/applibs/thestore.js";

// components

const toast = useToast();

export default {
  components: {
    QrcodeVue,
  },
  props: {
    currency: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      themain,
      token: Cookies.get("jwt") || Cookies.get("usid"),
      usid: Cookies.get("usid"),
      ethereumAddress: "",
      isRequestingAddress: false,
    };
  },

  async mounted() {
    var self = this;

    // Dapatkan wallet address dari API
    await self.getEthereumWalletAddress();
  },

  methods: {
    async getEthereumWalletAddress() {
      var self = this;
      var addressObj = await thestore.getEthereumWalletAddress(self.token);
      if (addressObj.success == true) {
        self.ethereumAddress = addressObj.data.wallet_address;
      }
    },

    async requestAnAddress() {
      var self = this;

      if (self.isRequestingAddress) {
        return;
      }

      self.isRequestingAddress = true;
      try {
        var res = await thestore.postRequestEthereumAddress(self.token);
        if (res.success == true) {
          self.ethereumAddress = res.data.wallet_address;
        } else {
          alert(res.msg);
        }
      } finally {
        self.isRequestingAddress = false;
      }
    },

    async copyAddressToClipboard() {
      const address = this.ethereumAddress;
      if (!address) {
        return;
      }

      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(address);
        } else {
          throw new Error("clipboard unavailable");
        }
        toast.success("Alamat berhasil disalin");
      } catch {
        const input = document.getElementById(`input_address_${this.currency}`);
        if (!input) {
          toast.error("Gagal menyalin alamat");
          return;
        }
        input.select();
        input.setSelectionRange(0, address.length);
        const copied = document.execCommand("copy");
        if (copied) {
          toast.success("Alamat berhasil disalin");
        } else {
          toast.error("Gagal menyalin alamat");
        }
      }
    },
  },
};
</script>

<style scoped>
.btn-outline-orange {
  color: #fedba1;
  border-color: #fedba1;
}
</style>
